import request from '@/request/request.js';

export function generatorDynamicRouter() {
	return request({
		url: '/get-head-route',
		method: 'get',
	});
}

export function getFooter() {
	return request({
		url: '/get-footer',
	});
}

export function getHomeSwiper() {
	return request({
		url: '/homeSwiper',
	});
}

export function getHomeAbout() {
	return request({
		url: '/home-about',
	});
}

export function getHomeBusiness() {
	return request({
		url: '/home-business',
	});
}

export function getHomeTochnology() {
	return request({
		url: '/home-technology',
	});
}

export function getHomeNews() {
	return request({
		url: '/home-news',
	});
}
export function getNewsList() {
	return request({
		url: '/get-news-list',
	});
}

export function getPosition() {
	return request({
		url: '/get-joinKewei-position',
	});
}

export function getBrandList() {
	return request({
		url: '/get-brand-list',
	});
}

export function getContent(data) {
	return request({
		url: '/get-Content',
		method: 'get',
		data: data,
	});
}
